import { Injectable } from '@angular/core';
import { BaseService } from '@core/service/base.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from "rxjs/index";
import {catchError, tap} from "rxjs/operators";
import {httpOptions} from "../../supplier/supplier-view/supplier-view.service";

@Injectable({
  providedIn: 'root',
})
export class PriceParityService extends BaseService {
  private url = 'api/priceList';
  private historyDetailUrl = 'api/priceList/getUpPriceByPlant'
  private detailurl = 'api/priceListDetail'
  constructor(http: HttpClient) {
    super(http);
  }
  public priceParityId:any;
  /**
   * 比价单对象
   */
  // priceParity:any = {
  //   id:null,
  //   orderNo: null,
  //   priceListName: null,
  //   purorgId: null,
  //   purorgCode: null,
  //   purorgName: null,
  //   plants: [],
  //   companyList:[],
  //   priceListDetails: [],
  //   inquiryTime: null,
  //   exclusive:false,
  //   exclusiveText:null,
  //   currency:null,
  //   purgrp:{
  //     purgrpName:null
  //   }
  // };
  getUrl(): string {
    return this.url;
  }
  getHistoryDetail(params): Observable<any> {
    return this.http.get(this.historyDetailUrl,
      {
        headers: httpOptions.headers,
        params: params,
      },
    ).pipe(
      tap(() => this.log('getHistoryDetail')),
      catchError(this.handleError('getHistoryDetail')),
    );
  }

  toBJDByIds(ids: any) : Observable<any> {
    const url = 'api/purRequisition/ids-tobjd';
    return this.http.put<any>(url, ids, httpOptions).pipe(
      tap(_ => this.log(`toBJDByIds`)),
      catchError(this.handleError<any>('查询出错'))
    );
  }

  findByids(ids: any) : Observable<any> {
    const url = 'api/priceListDetail/find-by-ids';
    return this.http.post<any>(url, ids, httpOptions).pipe(
      tap(_ => this.log(`findByids`)),
      catchError(this.handleError<any>('查询出错'))
    );
  }

  findByOrderNo(orderNo: any) : Observable<any> {
    const url = 'api/priceList/findOneByOrderNo';
    return this.http.post<any>(url, orderNo, httpOptions).pipe(
      tap(_ => this.log(`findOneByOrderNo`)),
      catchError(this.handleError<any>('查询出错'))
    );
  }
  getByFinished(params: HttpParams): Observable<any> {
    const url = `${this.detailurl}/get-all-finished`;
    return this.http.get(url,
      {
        headers: httpOptions.headers,
        observe: 'response',//完整数据返回，包括抬头
        params: params,
      },
    ).pipe(
      tap(() => this.log('query object')),
      catchError(this.handleError('get any', [])),
    );
  }
}
